module.exports = __webpack_public_path__ + "img/5.5211ab93.png";